export const skills = {
  "id": "panel-2",
  "type": "skills",
  "title": "Skill Sets",
  "groups": [
    {
      "heading": "Programming Languages",
      "items": [
        {
          "name": "Python/MicroPython",
          "icon": "devicon-python-plain"
        },
        {
          "name": "Java",
          "icon": "devicon-java-plain"
        },
        {
          "name": "JavaScript",
          "icon": "devicon-javascript-plain"
        },
        {
          "name": "C++",
          "icon": "devicon-cplusplus-plain"
        },
        {
          "name": "PHP",
          "icon": "devicon-php-plain"
        },
        {
          "name": "SQL",
          "icon": "devicon-mysql-plain"
        }
      ]
    },
    {
      "heading": "Development Platforms",
      "items": [
        {
          "name": "Git",
          "icon": "devicon-git-plain"
        },
        {
          "name": "VS Code",
          "icon": "devicon-vscode-plain"
        },
        {
          "name": "IntelliJ",
          "icon": "devicon-intellij-plain"
        },
        {
          "name": "ROS",
          "icon": "devicon-ros-original"
        },
        {
          "name": "Spring Boot",
          "icon": "devicon-spring-original"
        },
        {
          "name": "Docker",
          "icon": "devicon-docker-plain"
        }
      ]
    },
    {
      "heading": "General Robotics",
      "items": [
        {
          "name": "Kinematics",
          "icon": "robot"
        },
        {
          "name": "LiDAR",
          "icon": "signal"
        },
        {
          "name": "TurtleBots",
          "icon": "devicon-ros-original"
        },
        {
          "name": "Arduino",
          "icon": "devicon-arduino-plain"
        }
      ]
    }
  ],
  "document": {
    "url": "./pdfs/ohResume.pdf",
    "heading": "PDF Resume",
    "title": "Oliver Hill Resume",
    "filename": "oliverHillResume.pdf"
  }
};
